import React,{useEffect, useState} from 'react'
import {Container,Row,Col,Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getLabors, removeLabor  } from '../../../actions/laborsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Labors() { 
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true) 
    const {labors, loading, result} = useSelector(state=>state.labors) 
    const dispatch = useDispatch()
    
    useEffect(()=>{
        dispatch(getLabors())
    }, [dispatch])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('labors.itsok'),
                    icon: 'error',
                    text: t('labors.'+result.message+'0') + result.count + t('labors.'+result.message+'1')
                })
                dispatch({
                    type: 'LABOR_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('labors.letsok'),
                    icon: 'success',
                    text: t('labors.deletedlabor')
                })
                dispatch({
                    type: 'LABOR_RESET_RESULT'
                })
            }
        }
    }, [result, t, dispatch])

    const deleteLabor = (idLabor) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeLabor(idLabor))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    // Datatables
    const columns = [
        {
            name: t('labors.name'),
            cell: datos =>
                <div>
                    {datos.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('labors.requiremachinery'),
            cell: datos =>
                <div>
                    {datos.require_machinery
                        ?
                        <>{t('labors.yes')}</>
                        :
                        <>{t('labors.no')}</>
                    }
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('labors.images'),
            cell: datos =>
                <div>
                    { datos?.image?.length>0
                    ?
                        <img src={datos.image} width='100px' alt=''/>
                    :
                        <>{t('labors.thereisnt')}</>
                    }
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: '',
            cell: datos =>
            <>
                <Button variant="outline-info mx-auto" href={`/admin/labor/`+datos._id}>
                    <i className="fas fa-clipboard-list"></i> <i className="fas fa-edit fa-sm"></i>
                </Button>
                <Button variant="outline-danger mx-auto" onClick={() => deleteLabor(datos._id)}>
                    <i className="fas fa-clipboard-list"></i> <i className="fas fa-minus fa-sm"></i>
                </Button>
            </>
        }
    ]
      
    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>        
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('labors.editlabor')}</h1> 
                        <label className='mb-2'>{t('labors.selectlabor')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/labor`}>
                                <i className="fas fa-clipboard-list"></i> {t('labors.new')}
                            </Button>
                        </Row>
                        <Row className="text-center justify-content-center">
                            {labors 
                                ?
                                    <CustomDataTable columns={columns} data={labors} />
                                :
                                    <></>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}